/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
//import Footer from "components/Footer/Footer.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2022/02/bring-website-back-from-the-dead/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2022/02/bring-website-back-from-the-dead/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/2022/02/bring-website-back-from-the-dead/SectionBlogInfo.js";
import styles from "../../../../pages-sections/services/ServicesSections.module.scss";






export const metadata = {
  title: "Bringing a Website Back from the Dead! - Tribalism",
  date: "2022-02-21",
  summary: "We are an Australian Digital Marketing Agency based in Melbourne. We can help you with your GTM setup! Have you lost your website due to an email/payment malfunction? Thought it was lost forever? Read on...",
  image: "https://www.tribalism.com.au/img/posts/2022-02-21-bring-website-back-from-the-dead/34.jpg",
  url: "https://www.tribalism.com.au/blog-post/2022/02/bring-website-back-from-the-dead",
  author: "Scott Sunderland",
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.png" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="Bringing a Wesbite back from the dead! - Tribalism"
        image="https://www.tribalism.com.au/img/posts/2022-02-21-bring-website-back-from-the-dead/34.jpg"
        url="https://www.tribalism.com.au/blog-post/2022/02/bring-website-back-from-the-dead"
        type="article"
        description="We are an Australian Digital Marketing Agency based in Melbourne. We can help you with your GTM setup!"
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/posts/2022-02-21-bring-website-back-from-the-dead/34.webp" filter="dark">
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.title}>
              Bringing a Wesbite back from the dead!
              </h1>
              <h4 className={classes.subtitle}>

              Have you lost your website due to a email/payments malfucntion. Thought it was lost forever? Read on...
              <br></br>
              <br></br>
              Posted by: Scott Sunderland


              </h4>
              <br />
              <Button color="warning" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />

        </div>
      </div>



      <Footer
       
      />
    </div>
  );
}
